<template>
	<el-card class="box-card" shadow="never"> 
	  <el-row class="type-item">
	    <el-col class="type-left" :span="2">
	      类型：
	    </el-col>
	    <el-col :span="22">
	      <el-tag size="small" type="success">所有（10861）</el-tag>
	      <el-tag size="small" type="info">专利成果（38）</el-tag>
	      <el-tag size="small">外文期刊（657）</el-tag>
	      <el-tag size="small" type="info">中文论文（10166）</el-tag>
	    </el-col>
	  </el-row>
	  <el-row class="type-item">
	    <el-col class="type-left" :span="2">
	      选择：
	    </el-col>
	    <el-col :span="22">
	      <el-tag size="small" type="success">所有（10861）</el-tag>
	      <el-tag size="small" type="info">不包含全文（10861）</el-tag>
	    </el-col>
	  </el-row>
	  <el-row class="type-item">
	    <el-col class="type-left" :span="2">
	      收录情况：
	    </el-col>
	    <el-col :span="22">
	      <el-tag size="small" type="success">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	    </el-col>
	  </el-row>
	  <el-row class="type-item">
	    <el-col class="type-left" :span="2">
	      年度：
	    </el-col>
	    <el-col :span="22">
	      <el-tag size="small" type="success">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	      <el-tag size="small" type="info">标签三</el-tag>
	    </el-col>
	  </el-row>
	</el-card>
</template>

<script>
	export default {
	    name: "tags",
	    data(){
	        return{
	            
	        }
	    },
	    methods:{
	
	    },
	    mounted() {
	
	    }
	
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tags.vue